import * as React from "react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { Intent, Button } from "@blueprintjs/core";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface ISaveButtonProps extends ICustomButtonProps {}

export const SaveButton: React.FunctionComponent<ISaveButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.FLOPPY_DISK}
      minimal={minimal}
      onClick={onClick}
      text={minimal ? null : text ? text : t(ETLCodes.General_Save)}
      intent={intent}
      loading={loading}
      disabled={disabled}
      type={onClick ? "button" : "submit"}
    />
  );
};
